module.exports = __webpack_public_path__ + "media/images/pages/primary-senior-leaders/build_confidence_in_your_teachers-befb7f0df3880596ed9c9efad844e85a.svg";